import ExportHtml from './export.html';

export function ExportStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'exportCtrl',
    name       : 'app.export',
    templateUrl: ExportHtml,
    url        : '/export'
  });
}